import { http } from '@services/http'; // or '@services/http' if you added aliases

export const csrf = () => http.get('/sanctum/csrf-cookie');
export const login = (email, password) => http.post('/login', { email, password });
export const verify2FA = (code) => http.post('/two-factor/verify', { code });
export const logout = () => http.post('/logout');
export const me = () => http.get('/api/user');
export const requestReset = (email) => http.post('/api/auth/resolve', { email });
export const resetPassword = (payload) => http.post('/reset-password', payload);
export const activateTraveler = ({ token, password, password_confirmation }) =>
  http.post('/api/activation', { token, password, password_confirmation });
